export const MARKET_TYPES = {
  Box_1: 0,
  Box_2: 1,
  Box_3: 2,
  Box_4: 3,
  Box_5: 4,
  Box_6: 5,
  RoyalFlush: 6,
  StraighFlush: 7,
  FourOfKind: 8,
  FullHouse: 9,
  Flush: 10,
  Straight: 11,
  ThreeOfKind: 12,
  TwoPairs: 13,
  OnePair: 14,
  HighCard: 15,
  Over: 16,
  Under: 17,
};

export const WIN_COMBINATIONS = {
  SuitUnder: 12,
  SuitOver: 11,
  'Color(over,under)': 10,
  RoyalFlush: 9,
  StraightFlush: 8,
  FourOfKind: 7,
  FullHouse: 6,
  Flush: 5,
  Straight: 4,
  ThreeOfKind: 3,
  TwoPairs: 2,
  OnePair: 1,
  HighCard: 0,
};

export const WIN_COMBINATIONS_NAMES = {
  12: 'SUIT_UNDER',
  11: 'SUIT_OVER',
  10: 'COLOR_LIMIT',
  9: 'ROYAL_FLUSH',
  8: 'STRAIGHT_FLUSH',
  7: 'FOUR_OF_KIND',
  6: 'FULL_HOUSE',
  5: 'FLUSH',
  4: 'STRAIGHT',
  3: 'THREE_OF_KIND',
  2: 'TWO_PAIRS',
  1: 'ONE_PAIR',
  0: 'HIGH_CARD',
};

export const BOARD_CARD_WIN_TYPE = {
  Spades: 1,
  Hearts: 2,
  Diamonds: 3,
  Clubs: 4,
  Red: 5,
  Black: 6,
};

export const BOARD_CARD_WIN_TYPE_NAMES = {
  1: 'SPADES',
  2: 'HEARTS',
  3: 'DIAMONDS',
  4: 'CLUBS',
  5: 'RED',
  6: 'BLACK',
};

export const TABLE_BOX_TYPES = [
  MARKET_TYPES.Box_1,
  MARKET_TYPES.Box_2,
  MARKET_TYPES.Box_3,
  MARKET_TYPES.Box_4,
  MARKET_TYPES.Box_5,
  MARKET_TYPES.Box_6,
];

export const MARKET_GROUP_TYPES = {
  None: 0,
  WinningCombination: 1,
  WinningBox: 2,
  RedCards: 3,
  Spades: 4,
  Hearts: 5,
  Clubs: 6,
  Diamonds: 7,
};

export const BOARD_CARD_GROUP_TYPES = [
  MARKET_GROUP_TYPES.RedCards,
  MARKET_GROUP_TYPES.Spades,
  MARKET_GROUP_TYPES.Hearts,
  MARKET_GROUP_TYPES.Clubs,
  MARKET_GROUP_TYPES.Diamonds,
];

export const ROUND_PHASE_TYPES = {
  Initial: 0,
  PreFlop: 1,
  PreTurn: 2,
  PreRiver: 3,
};

export const ROUND_PHASE_KEYS_BY_TYPES = {
  0: 'Initial',
  1: 'PreFlop',
  2: 'PreTurn',
  3: 'PreRiver',
};

export const ROUND_PHASE_TYPES_NAMES = {
  0: 'INITIAL',
  1: 'PRE_FLOP',
  2: 'PRE_TURN',
  3: 'PRE_RIVER',
};

export const ROUND_PHASE_OBJECT_KEYS = {
  INITIAL: 0,
  PRE_FLOP: 1,
  PRE_TURN: 2,
  PRE_RIVER: 3,
};

export const ODD_CHANGE_TYPES = {
  none: 0,
  under: 1,
  over: 2,
};

export const BETS_NAMES_BY_MARKET_TYPE = {
  [MARKET_TYPES.Box_1]: 'BOX_1',
  [MARKET_TYPES.Box_2]: 'BOX_2',
  [MARKET_TYPES.Box_3]: 'BOX_3',
  [MARKET_TYPES.Box_4]: 'BOX_4',
  [MARKET_TYPES.Box_5]: 'BOX_5',
  [MARKET_TYPES.Box_6]: 'BOX_6',
  [MARKET_TYPES.RoyalFlush]: 'ROYAL_FLUSH',
  [MARKET_TYPES.StraighFlush]: 'STRAIGH_FLUSH',
  [MARKET_TYPES.FourOfKind]: 'FOUR_OF_KIND',
  [MARKET_TYPES.FullHouse]: 'FULL_HOUSE',
  [MARKET_TYPES.Flush]: 'FLUSH',
  [MARKET_TYPES.Straight]: 'STRAIGHT',
  [MARKET_TYPES.ThreeOfKind]: 'THREE_OF_KIND',
  [MARKET_TYPES.TwoPairs]: 'TWO_PAIRS',
  [MARKET_TYPES.OnePair]: 'ONE_PAIR',
  [MARKET_TYPES.HighCard]: 'HIGH_CARD',
  [MARKET_TYPES.Over]: 'OVER',
  [MARKET_TYPES.Under]: 'UNDER',
};

export const BETS_NAMES_BY_GROUP_TYPES = {
  [MARKET_GROUP_TYPES.RedCards]: 'RED_CARDS',
  [MARKET_GROUP_TYPES.Clubs]: 'CLUBS',
  [MARKET_GROUP_TYPES.Spades]: 'SPADES',
  [MARKET_GROUP_TYPES.Hearts]: 'HEARTS',
  [MARKET_GROUP_TYPES.Diamonds]: 'DIAMONDS',
};

export const BOX_CARDS_COUNT = [0, 1];
